import axios from 'axios'
import { getRestApiConfig } from '../config'

export const postFile = async (file?: FormData, synonym?: string): Promise<any> => {
    const restApiConfig = getRestApiConfig()
    const options = {
        headers: { ...restApiConfig.authHeader },
    }
    const endpointUrl = new URL(`/api/v1/File?synonym=${synonym}`, restApiConfig.baseUrl).href
    const response = await axios
        .post(endpointUrl, file, options)
        .then((res) => {
            return undefined
        })
        .catch((err) => {
            return err.response.data.detail
        })
    return response
}

export const transformToFormdata = (fileList: FileList): FormData => {
    const data = new FormData()
    data.append('file', fileList[0])
    return data
}
